// extracted by css-extract-rspack-plugin
export default {"mobile-guide":"mobile-guide-sGc4u","mobileGuide":"mobile-guide-sGc4u","content":"content-dML1k","text":"text-csbPX","close":"close-Wh0xs","role":"role-M1Ve7"};